<template>
	<div class="taskDetail">
		<el-card class="box-card" shadow="never">
			<div>
				<div class="taskName">{{ detail.name }}</div>
				<div class="companyName">{{ detail.customerName }}</div>
				<div class="editArea">
					<el-row type="flex" style="align-items: baseline">
						<el-col>
							<span class="inline" v-if="detail.level === 0">
								负责人：{{ detail.leaderName || '未指定' }}
								<ig-icon class="icon" name="brush" @click.native="showEdit('leader')"></ig-icon>
							</span>
							<span class="inline">
								服务人员： {{ detail.appointorName || '未指定' }}
								<ig-icon @click.native="showEdit('appointor')" class="icon" name="brush"></ig-icon>
							</span>
							<span class="inline">创建时间：{{ detail.createDate }}</span>
							<span class="inline">
								截止时间：{{ detail.expirationDate || '-' }}
								<ig-icon
									class="icon"
									name="brush"
									@click.native="showEdit('expirationDate')"
								></ig-icon>
							</span>
						</el-col>

						<el-button type="primary" @click="changeStatus" :loading="loadingBtn" size="small">{{
							getCurrentStatus
						}}</el-button>
					</el-row>
				</div>
			</div>
		</el-card>
		<!-- 子任务列表 -->
		<el-card class="box-card block" shadow="never" v-if="detail.level === 0">
			<div>
				<el-row type="flex" justify="space-between">
					<div>子任务列表</div>
					<div style="width: 180px">
						<el-progress :percentage="getPercent" :stroke-width="15"></el-progress>
					</div>
				</el-row>
				<div class="scroll">
					<el-scrollbar class="dialogScroll">
						<data-list
							:table-style="{ name: 'grey' }"
							class="datalist"
							:data="subList"
							:columns="column"
							:loading="loading"
							:btnList="btnList"
              :selection="true"
							@selection-change="selectionChange"
						></data-list>
					</el-scrollbar>
				</div>
			</div>
		</el-card>
		<el-row :gutter="10" class="block" type="flex">
			<el-col :span="12">
				<el-card class="box-card" shadow="never">
					<div slot="header" class="clearfix">
						<span>上传附件</span>
					</div>
					<sky-upload-img
						v-model="detail.taskFiles"
						platform="iglobalwin-pri-oss"
						:upload-success="upload"
						:remove-success="remove"
					></sky-upload-img>
				</el-card>
			</el-col>
			<el-col :span="12">
				<el-card class="box-card" style="height: 100%" shadow="never">
					<div slot="header" class="clearfix">
						<span>反馈描述</span>
						<el-button
							style="float: right; padding: 3px 0"
							type="text"
							@click="showEdit('describe')"
							>编辑</el-button
						>
					</div>
					<div>{{ feedback || '暂未填写反馈描述....' }}</div>
				</el-card>

				<el-dialog title="修改信息" :visible.sync="dialogVisible" width="30%">
					<component
						:is="component.componentName"
						v-bind="component"
						v-model="val"
						@change="changeinfor"
					></component>
					<span slot="footer" class="dialog-footer">
						<el-button @click="informCancel">取 消</el-button>
						<el-button type="primary" @click="previewInform" :loading="loadingBtn">确 定</el-button>
					</span>
				</el-dialog>
			</el-col>
		</el-row>
		<div v-if="detail.id" class="block">
			<sky-remarks :id="detail.id"></sky-remarks>
		</div>

		<!-- 预览模态框 -->
		<carousel-dialog
			:dialog="carouselDialog"
			:carousel="carousel"
			@carouseChange="carouseChange"
			@confirm="submit"
		>
			<el-row class="auto-trigger">
				<el-col :span="24" class="title">确认提示</el-col>
				<el-col :span="24" class="message">
					您当前的操作会触发{{ autoTriggerData.length }}条自动通知，通知内容如下
				</el-col>
				<el-col :span="24" class="content">
					<div class="content-item">
						<span class="item-name">邮件标题：</span>
						<div class="data">{{ activeTrigger.title }}</div>
					</div>
					<div class="content-item">
						<span class="item-name">收件人：</span>
						<div class="data">
							<span v-for="(item, index) in activeTrigger.recipientList" :key="index"
								>{{ item }}
							</span>
						</div>
					</div>
					<div class="content-item">
						<span class="item-name">抄送人：</span>
						<div class="data">
							<span v-for="(item, index) in activeTrigger.ccPeopleList" :key="index"
								>{{ item }}
							</span>
						</div>
					</div>
					<div class="content-item">
						<span class="item-name">附件：</span>
						<div class="data">
							<div
								v-for="(item, index) in activeTrigger.fileList"
								:key="index"
								class="accessory"
								@click="accessoryUrl(item.url)"
							>
								{{ item.url }}
							</div>
						</div>
					</div>
					<div class="content-item">
						<span class="item-name">内容：</span>
						<div class="information" v-html="activeTrigger.content"></div>
					</div>
				</el-col>
			</el-row>
		</carousel-dialog>

		<!-- 批量设置服务人员 -->
		<batchAppointForm ref="batchAppointForm" dialogWidth="500px" title="选择服务人员" />
	</div>
</template>

<script>
import task from '@/backend/services/task/task.js';
import skyRemarks from '@/components/task/taskDetail/sky-remarks';
import detailBtn from '@/components/task/taskList/detailBtn';
import carouselDialog from '@/components/task/carouselDialog/carouselDialog';
import userSearch from '@/components/tools/userSearch';
import { taskStatus } from '@/common/dictionary';
import { formatElementPerc } from '@/common/util';
import editText from '@/components/tools/edit_text';
import batchAppointForm from './batchAppointForm';

export default {
	name: 'taskDetail',
	components: {
		userSearch,
		skyRemarks,
		carouselDialog,
		batchAppointForm,
	},
	data() {
		let that = this;
		return {
			dialogVisible: false,
			input: '',
			loadingBtn: false,
			detail: {
				taskFiles: [],
			},
			feedback: '',
			component: {},
			status: {},
			val: '',
			type: 'appointor',
			editType: {
				appointor: {
					componentName: 'userSearch',
				},
				describe: {
					componentName: 'el-input',
					type: 'textarea',
				},
				expirationDate: {
					componentName: 'el-date-picker',
					type: 'date',
					'value-format': 'yyyy-MM-dd',
				},
				leader: {
					componentName: 'userSearch',
				},
			},
			btnList: [
				{
					name: '设置服务人员',
					position: 'left',
					attribute: {
						type: 'primary',
						size: 'small',
						loading: false,
					},
					async btnClick() {
						let { tableRow } = that;
						let { cancel } = await that.$refs.batchAppointForm.show({
							tableRow,
						});
						if (!cancel) {
							that.getDetail(that.detail.id)
						}
					},
				},
			],
			subList: [],
			fileList: [],
			tableRow: [],
			column: [
				{
					label: '',
					bind(row, index) {
						return ++index;
					},
					width: 80,
					align: 'center',
				},
				{
					label: '任务名称',
					bind: 'name',
					type: 'custom',
					url: '/task/taskSubDetail',
					componentName: detailBtn,
					query(row) {
						return { id: row.id };
					},
				},
				{
					label: '服务人员',
					bind: 'appointorName',
					type: 'custom',
					componentName: editText,
					config: {
						componentType: 'userSearch',
					},
					async triggerEvent(row, data, cb) {
						await that.editTaskDetail(row.id, 'appointor', data);
						cb();
					},
				},
				{
					label: '截止时间',
					bind: 'expirationDate',
					type: 'custom',
					componentName: editText,
					config: {
						componentType: 'el-date-picker',
						type: 'date',
						'value-format': 'yyyy-MM-dd',
					},
					async triggerEvent(row, data, cb) {
						await that.editTaskDetail(row.id, 'expirationDate', data);
						cb();
					},
				},
				{
					label: '最后操作时间',
					bind: 'modifiedTime',
					showOverflowTooltip: true,
				},
				{
					label: '反馈描述',
					bind: 'describe',
					type: 'custom',
					showOverflowTooltip: true,
					componentName: editText,
					config: {
						componentType: 'sky-textarea',
					},
					async triggerEvent(row, data, cb) {
						await that.editTaskDetail(row.id, 'describe', data);
						cb();
					},
				},
				{
					label: '状态',
					bind: 'statusName',
					type: 'custom',
					align: 'center',
					componentName: editText,
					config: {
						componentType: 'sky-select',
						options: taskStatus,
					},
					style: {
						justifyContent: 'center',
					},
					showButton() {
						return true;
					},
					async triggerEvent(row, data, cb) {
						await that.editTaskDetail(row.id, 'status', data);
						cb();
					},
					getClass(row) {
						let status = taskStatus.find(item => row.status === item.value);
						return `text-${status.class}`;
					},
				},
			],
			// 模态框配置
			carouselDialog: {
				width: '45%',
				visible: false,
			},
			// 走马灯配置
			carousel: {
				height: '400px',
				autoplay: false,
				arrow: 'always',
				indicator: 'outside',
				data: [],
			},
			changeinforStatus: false,
			autoTriggerData: [],
			activeTrigger: {},
			triggerType: '',
			triggerVal: '',
		};
	},
	computed: {
		getCurrentStatus() {
			let that = this;
			let status = {};
			if (that.detail.status) {
				status = taskStatus.find(item => item.value === that.detail.status);
				that.status = status;
			}
			return status.btnInfo;
		},
		getPercent() {
			if (this.detail.count === 0) return 0;
			return formatElementPerc((this.detail.finishCount / this.detail.count) * 100);
		},
	},
	methods: {
		upload(file) {
			task
				.addFile({
					relationId: this.detail.id,
					file: this.formatImg(file),
				})
				.then(val => {
					file.id = val.data;
					// this.getDetail(this.detail.id)
				});
		},
		async remove(file) {
			await task.removeFile(file.id);
			this.$message({
				message: '删除成功',
				type: 'success',
			});
		},
		formatImg(obj) {
			return {
				fileName: obj.name || obj.fileName,
				ossName: obj.ossName,
				url: obj.url,
			};
		},
		changeStatus() {
			this.val = this.status.nextStatus;
			this.type = 'status';
			this.changeinforStatus = true;
			this.previewInform();
		},
		// 获取任务详情
		async getDetail(id) {
			try {
				let val = await task.getTaskDetail(id);
				this.detail = val.data;
				this.feedback = val.data.describe;
				if (this.detail.level === 0) {
					this.getSub(id);
				}
			} catch (err) {
				this.$message.warning('获取任务详情失败');
			}
		},
		// 获取子任务列表
		async getSub(id) {
			this.loading = true;
			try {
				let val = await task.getSubTaskList(id);
				this.subList = val.data;
				this.loading = false;
			} catch (error) {
				this.loading = false;
			}
		},
		// 显示模态框
		showEdit(type) {
			this.type = type;
			this.component = this.editType[type];
			this.val = this.detail[type];
			this.dialogVisible = true;
		},
		// 修改任务
		submit() {
			this.loadingBtn = true;
			task
				.editTaskDetail(this.detail.id, {
					[this.type]: this.val,
				})
				.then(() => {
					this.$message({
						message: '修改成功',
						type: 'success',
					});
					this.dialogVisible = false;
					this.loadingBtn = false;

					this.type === 'status' ? this.getDetail(this.detail.id) : (this.feedback = this.val);
				})
				.catch(() => {
					this.loadingBtn = false;
				});
		},
		async editTaskDetail(id, bind, value) {
			if (!value) {
				this.$message.info('请输入内容');
				return false;
			}
			try {
				await task.editTaskDetail(id, {
					[bind]: value,
				});
				this.$message.success('更新成功');
				await this.getSub(this.$route.query.id);
			} catch (error) {
				this.$message.warning('更新失败');
			}
		},
		// 幻灯片切换
		carouseChange(index) {
			this.activeTrigger = this.autoTriggerData[index];
		},
		changeinfor() {
			this.changeinforStatus = true;
		},
		// 修改信息-取消
		informCancel() {
			this.dialogVisible = false;
			this.changeinforStatus = false;
		},
		// 触发预览
		async previewInform() {
			// 反馈描述
			if (this.type === 'describe') {
				this.submit();
				return false;
			}
			// 空值判断
			if (!this.val || !this.changeinforStatus) {
				this.$message({
					message: '请修改',
					type: 'warning',
				});
				this.dialogVisible = false;
				return false;
			}

			this.changeinforStatus = false;
			let type = this.type;
			let val = this.val;
			let id = this.detail.id;
			switch (type) {
				case 'leader':
					type = 'LEADER';
					break;
				case 'appointor':
					type = 'ASSIGNED_TO';
					break;
				case 'expirationDate':
					type = 'EXPIRATION_DATE';
					break;
				case 'status':
					type = 'TASK_STATUS';
					break;
			}
			switch (val) {
				case 1:
					val = 'WAITING_TO_START';
					break;
				case 2:
					val = 'PROCESSING';
					break;
				case 3:
					val = 'FINISHED';
					break;
				default:
					val = 'CHANGE';
					break;
			}
			try {
				let res = await task.previewInform({
					conditionFieldEnum: type,
					conditionStatusEnum: val,
					taskId: id,
				});

				if (res.data.length == 0) {
					this.submit();
					return false;
				}
				if (res.data.length <= 1) {
					this.carousel.arrow = 'never';
					this.carousel.indicator = 'none';
				} else {
					this.carousel.arrow = 'always';
					this.carousel.indicator = 'outside';
				}
				this.dialogVisible = false;
				this.autoTriggerData = res.data;
				this.activeTrigger = res.data[0];
				res.data.forEach((item, index) => {
					this.carousel.data.push({ label: index });
				});
				this.carouselDialog.visible = true;
			} catch (error) {
				this.dialogVisible = false;
			}
		},
		// 跳转附件
		accessoryUrl(url) {
			window.open(url);
		},
		// 多选操作
		selectionChange(column) {
			this.tableRow = column;
		},
	},
	created() {
		this.getDetail(this.$route.query.id);
	},
};
</script>

<style lang="scss" scoped>
.taskDetail {
	.block {
		margin-top: 10px;
	}

	.box-card {
		.clearfix {
			font-size: 16px;
			line-height: 22px;
		}

		.taskName {
			font-size: 12px;
			color: #666;
		}

		.companyName {
			font-size: 16px;
			color: #333;
			margin: 20px 0;
		}

		.editArea {
			.inline + .inline {
				margin-left: 24px;
				font-weight: 600;
			}

			.icon {
				color: #999;

				/* font-size: 14px; */
				cursor: pointer;
				margin-left: 10px;

				&:hover {
					color: #54a8fe;
				}
			}
		}

		.scroll {
			height: 300px;
			padding: 20px;
		}

		.datalist {
			border: 1px solid #ebeef5;
			border-bottom: none;
			margin: 10px 10px 0;
		}
	}
}
</style>
<style lang="scss">
.dialogScroll {
	height: 100%;

	& > .el-scrollbar__wrap {
		overflow-x: hidden;
	}
}
// 触发预览
.auto-trigger {
	width: 100%;
	height: 100%;
	font-size: 14px;
	color: #333;
	padding: 0 60px;

	.title {
		text-align: center;
		font-size: 18px;
	}

	.message {
		text-align: center;
		margin: 20px 0 30px;
	}

	.content {
		.content-item {
			margin-bottom: 15px;
			display: flex;

			.item-name {
				width: 80px;
				display: inline-block;
				text-align: right;
				margin-right: 20px;
			}

			.data {
				flex: 1;
				// 单行溢出
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;

				.accessory {
					cursor: pointer;
					color: #5aa0ff;
					margin: 5px;
				}
			}

			.information {
				max-height: 150px;
				flex: 1;
				word-break: break-all;
				overflow: auto;
				padding-right: 2px;
			}

			.information::-webkit-scrollbar {
				width: 5px;
				height: 1px;
			}

			.information::-webkit-scrollbar-thumb {
				border-radius: 2px;
				background: #e8e8e8;
			}

			.information::-webkit-scrollbar-track {
				border-radius: 2px;
				background: #fff;
			}
		}
	}
}
</style>
